// Admin-website passwords: at least 6 characters, typed twice the same (as the server checks).
export const MIN_PASSWORD_LENGTH = 6;

// What is wrong with a new password and its confirmation, or null. Optional (the District Manager edit
// form): blank in both fields means "keep the current password".
export function newPasswordProblem(password, confirmation, { optional = false } = {}) {
	const value = password == null ? '' : String(password);
	const again = confirmation == null ? '' : String(confirmation);
	if (optional && value === '' && again === '') {
		return null;
	}
	if (value.length < MIN_PASSWORD_LENGTH) {
		return 'The new password must be at least ' + MIN_PASSWORD_LENGTH + ' characters.';
	}
	if (value !== again) {
		return 'The new password and its confirmation do not match.';
	}
	return null;
}
